"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = exports.PlaceholderImage = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var PlaceholderImage = function () { return react_1.default.createElement(exports.Image, { className: "image" }); };
exports.PlaceholderImage = PlaceholderImage;
exports.Image = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 0;\n  padding-top: 100%;\n  display: block;\n  position: relative;\n"], ["\n  width: 100%;\n  height: 0;\n  padding-top: 100%;\n  display: block;\n  position: relative;\n"])));
exports.default = exports.PlaceholderImage;
var templateObject_1;
